import axios from "axios";

export default {
  namespaced: true,
  state: {
    file: null,
    files: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    filesMessage: ''
  },
  mutations: {
    RECEIVED_FILES(state, payload) {
      state.files = payload;
      state.isReceiving = false;
    },
    RECEIVED_FILE(state, payload) {
      state.file = payload;
    },
    RECEIVING_FILES(state) {
      state.isReceiving = true;
    },
    RECEIVING_FILE(state) {
      state.isReceiving = true;
    },
    UPDATED_FILE(state, payload) {
      let index = state.files.findIndex(file => file._id === payload._id);
      state = Object.assign(state, {
        files: state.files.map((file, i) => {
          if (i === index) {
            return Object.assign({}, file, payload);
          }
          return file;
        }),
        isUpdating: false,
        filesMessage: 'Files has been updating!',
      })
    },
    UPDATING_FILE(state) {
      state.isUpdating = true;
    },
    DELETED_FILE(state, payload) {
      let indexToDelete = state.files.findIndex(file => file._id === payload._id);
      let files = [...state.files];
      files.splice(indexToDelete, 1);
      state = Object.assign(state, {
        files: [...files],
        isDeleting: false,
        idToDelete: null,
        filesMessage: 'File has been Deleted!',
      });
    },
    DELETING_FILE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getEmployeeFiles({dispatch}, id) {
      dispatch("receivingFiles");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/files/employee/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receivedFiles", response.data);
      return response.data;
    },
    async getPayrollFiles({dispatch}, id) {
      dispatch("receivingFiles");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/files/payroll/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receivedFiles", response.data);
      return response.data;
    },
    async getPurchaseOrderFiles({dispatch}, id) {
      dispatch("receivingFiles");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/files/purchaseorder/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receivedFiles", response.data);
      return response.data;
    },
    async getSalesOrderFiles({dispatch}, id) {
      dispatch("receivingFiles");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/files/salesorder/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers})
      dispatch("receivedFiles", response.data);
      return response.data;
    },
    async insertRouteFile({dispatch}, payload) {
      try{
        if(payload.file == undefined || payload.file == null) return;
        dispatch("receivingFiles");
        let url = 'https://api.accountxc.com:3100/insert/file/route/' + payload.id;
        console.log(payload.id)
        let data = new FormData();
        data.append('file', payload.file); 
        delete payload['file'];
        delete payload['id'];
        for (let x in payload) {data.append(x, payload[x]);}
        let token = localStorage.getItem('token');
        console.log(token)
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertEmployeeFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        console.log("HERE", payload);
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/employee/' + payload.employeeid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertPayrollFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        if(payload.file==null) return null;
        console.log("payroll", payload)
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/file/payroll/' + payload.payrollid;
        let data = new FormData();
        data.append('file', payload.file); 
        data.append('filename', payload.filename);
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        console.log(e.data)
        return null;
      }
    },
    async insertReimbursementFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/reimbursement/' + payload.reimbursementid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertPurchaseOrderFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/purchaseorder/' + payload.purchaseorderid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertSalesOrderFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/salesorder/' + payload.salesorderid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async insertBillFile({dispatch}, payload) {
      try{
        dispatch("receivingFiles");
        let url;
        let data;
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        if(payload.file !== undefined) {
          url = 'https://api.accountxc.com:3100/insert/file/bill/' + payload.billid;
          data = new FormData();
          data.append('file', payload.file); 
          delete payload['file'];
          for (let x in payload) {data.append(x, payload[x]);}
          let response = await axios({method: "POST", url: url, headers: headers, data: data});
          return response.data;
        } 
        else{
          return null;
        }
      }
      catch(e){
        return null;
      }
    },
    async deleteFileRequest({dispatch}, payload) {
      try{
        dispatch("updatingFile");
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/file/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getDownloadFile({dispatch}, url){
      dispatch("updatingFile");
      const response = await fetch(url);
      let data = await response.blob();
      let blob = new Blob([data], { type: 'application/pdf' });
      let filesrc = URL.createObjectURL(blob);
      return filesrc;
    },
    receivedFiles({commit}, payload) {
      commit("RECEIVED_FILES", payload)
    },
    receivingFiles({commit}) {
      commit("RECEIVING_FILES")
    },
    receiveFile({commit}, payload) {
      commit("RECEIVED_FILE", payload)
    },
    receivingFile({commit}) {
      commit("RECEIVING_FILE")
    },
    updateFile({commit}, payload) {
      commit("UPDATED_FILE", payload)
    },
    updatingFile({commit}) {
      commit("UPDATING_FILE")
    },
    deleteFile({commit}, payload) {
      commit("DELETED_FILE", payload)
    },
    deletingFile({commit}, payload) {
      commit("DELETING_FILE", payload)
    }
  },
};
